module.exports = __webpack_public_path__ + "img/jaoc_pop_firstplaceteam_background.37d7ba3a.jpg";